/**
 * StatusPill — pill compacta com borda + fundo a 10% + foreground colorido.
 *
 * Padrão visual replicado do protótipo (painel-screens.jsx:200) para status
 * operacionais que pedem maior peso visual que o <Badge>. Diferente do
 * <Badge>:
 *   - StatusPill tem borda explícita (uppercase + tracking, "etiqueta de
 *     estado") — usar em listas que misturam várias linhas de mesmo tom.
 *   - Badge é mais leve (sem borda, lowercase) — usar em metadados inline.
 *
 * Consolida ActivePill (StoresPage) e StatusPill inline (DashboardPage),
 * preservando rotulos pt-BR direto.
 */

import { cn } from "@/lib/utils";

export type StatusTone = "success" | "warn" | "destructive" | "muted";

const TONE_CLASS: Record<StatusTone, string> = {
  success:
    "border-[var(--color-success)] bg-[var(--color-success)]/10 text-[var(--color-success)]",
  warn:
    "border-[var(--color-warning)] bg-[var(--color-warning)]/10 text-[var(--color-warning)]",
  destructive:
    "border-[var(--color-destructive)] bg-[var(--color-destructive)]/10 text-[var(--color-destructive)]",
  muted:
    "border-[var(--color-border)] bg-[var(--color-muted-tint)] text-[var(--color-muted-foreground)]",
};

export interface StatusPillProps {
  tone: StatusTone;
  children: React.ReactNode;
  className?: string;
}

export function StatusPill({ tone, children, className }: StatusPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.04em]",
        TONE_CLASS[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
